import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'

axios.defaults.timeout = 60000 //响应时间
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'; //配置请求头
let URL = ''
if (process.env.NODE_ENV === 'production') {
  URL = location.origin + location.pathname.match(/^\/\w+/g)[0] + '/api/v1'
} else {
  // URL = 'accelerator_test/api/v1'
  URL = 'accelerator/api/v1'
  // URL = 'coweb/api/v1'
}
axios.defaults.baseURL = URL
axios.interceptors.response.use(
  success => {
    if (success.data.code == 20000 || success.request.responseURL.indexOf('spcialquestion/answer') != -1) {
      return Promise.resolve(success)
    } else if (success.data.code === 10000 || success.data.code === 11001) {
      let { origin, pathname, hash } = location
      let url = origin + pathname + 'POUND' + hash.substr(1, hash.length - 1)
      console.log('跳转连接：' + url)
      location.href = url
    } else {
      Vue.$vux.toast.show({ text: success.data.message, type: 'text' })
      return Promise.reject(success)
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default {
  post(url, params) {
    return axios.post(url, qs.stringify(params))
  },
  get(url, params) {
    return axios.get(url, { params })
  },
  json(url, params) {
    return axios.post(url, params, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  upLoad(url, params) {
    return axios.post(
      url,
      { params: params },
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/util/http.js